fragment CustomerFragment on Customer {
        id
        first_name
        last_name
        email
        discount_group_id

        discountGroup {
            ...DiscountGroupFragment
        }

        ext_customer_id
        ext_company_id
        currency
        payment_terms
        billing_address {
            ...BillingAddressFragment
        }
        shipping_addresses
        default_locale
}